import type {ProductCategory} from '../../types';

import {Chip, Skeleton, Tabs} from '@ds/components';

type ProductCategoriesProps = {
  categories: ProductCategory[];
  categoriesLoading: boolean;
  subCategories: ProductCategory[];
  subCategoriesLoading: boolean;
  selectedCategoryId: string | null;
  selectedSubCategoryId: string | null;
  onCategoryChange: (categoryId: string) => void;
  onSubCategoryChange: (subCategoryId: string) => void;
};

const ProductCategories: React.FC<ProductCategoriesProps> = ({
  categories,
  categoriesLoading,
  subCategories,
  subCategoriesLoading,
  selectedCategoryId,
  selectedSubCategoryId,
  onCategoryChange,
  onSubCategoryChange
}) => {
  if (categoriesLoading) {
    return (
      <div className="flex gap-4 overflow-hidden px-4 py-2">
        {Array.from({length: 4}, (_, index) => (
          <Skeleton.Button key={index} active size="small" className="h-8! w-20! shrink-0" />
        ))}
      </div>
    );
  }

  return (
    <section className="my-2 max-w-full">
      <Tabs
        activeKey={selectedCategoryId ?? undefined}
        onChange={onCategoryChange}
        items={categories.map((category) => ({
          key: String(category.id),
          label: category.title
        }))}
        tabBarClassName="mb-2"
      />

      {selectedCategoryId && (
        <div className="flex overflow-x-auto px-4">
          {subCategoriesLoading ? (
            <div className="flex gap-2">
              {['w-20!', 'w-30!', 'w-16!', 'w-30!', 'w-20!'].map((widthClass, index) => (
                <Skeleton.Button
                  key={index}
                  active
                  size="small"
                  className={`h-8! shrink-0 rounded-full! ${widthClass}`}
                />
              ))}
            </div>
          ) : (
            <div className="flex w-max gap-2">
              {subCategories.map((subCategory) => (
                <Chip
                  key={subCategory.id}
                  label={subCategory.title}
                  selected={selectedSubCategoryId === String(subCategory.id)}
                  onClick={() => onSubCategoryChange(String(subCategory.id))}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default ProductCategories;
